const STORAGE_KEY = 'imagery:auth-return-to';

// Rejects '//host' and 'https://host' too, which navigate() would otherwise treat as a path.
const isInAppPath = (value: string) => /^\/app(\/|$)/.test(value);

/**
 * Remembers where to come back to after the OAuth round trip, which discards the current URL.
 * Storage survives the hand-off because it returns to the same tab and origin.
 */
export const saveAuthReturnTo = (pathWithSearch: string): void => {
  try {
    if (isInAppPath(pathWithSearch)) {
      globalThis.sessionStorage.setItem(STORAGE_KEY, pathWithSearch);
    }
  } catch {
    // sessionStorage may be unavailable (quota, privacy mode); sign-in falls back to the
    // organizations list
  }
};

/** Reads and clears the remembered destination, so a later sign-in cannot replay a stale one. */
export const takeAuthReturnTo = (): string | null => {
  try {
    const value = globalThis.sessionStorage.getItem(STORAGE_KEY);
    globalThis.sessionStorage.removeItem(STORAGE_KEY);
    return value && isInAppPath(value) ? value : null;
  } catch {
    return null;
  }
};
